import { EnvironmentProviders, Injectable, Provider } from "@angular/core"
import { TasksRoutesProvider } from "./lib/routes/tasks.routes";
import { TaskSidenavItem } from "./components/task-sidenav-item/task-sidenav-item";

@Injectable({ providedIn: 'root' })
export class TasksConfigService {
	constructor() {}
}

export const provideTasks = (): Array<Provider | EnvironmentProviders> => {
	return [
        { provide: TasksRoutesProvider.getToken(), useClass: TasksRoutesProvider, multi: true },
        { provide: TaskSidenavItem.getToken(), useClass: TaskSidenavItem, multi: true },
    ];
}